import { useEffect, useState } from 'react'

import Menu from '../../../../components/Peyks/Menu'
import peykIcon from '../../../../assets/svg/PPeykMessage.svg'

import { useNavigate } from 'react-router-dom'
import { notify } from '../../../../components/Toast'

import { useForm } from "react-hook-form"

import { get, post } from '../../../../services/http'
import { ToastContainer } from 'react-toastify'

export default function Index() {
  const navigate = useNavigate()
  
  const [clickButton, setClickButton] = useState(false)
  const [peyks, setPeyks] = useState('')
  
  const { register, handleSubmit } = useForm()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/peyks?token=${token}`)
      .then(respose => {
        setPeyks(respose.data.data.docs)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [token])

  const onSubmit = (data, e) => {
    e.preventDefault()
    setClickButton(true)

    post(`/api/admin/peyks/message?token=${token}`, { 
      title: data.title, 
      peyk: data.peyk, 
      messages: { manager: data.description }
    }).then(response => {
      if (response.data.messageFa === "پیغام جدید با موفقیت ساخته شد") {
        notify('success', 'پیغام جدید با موفقیت ارسال شد')
        setTimeout(() => {
          navigate('/peyk/messages')
        }, 2000)
      }
    }).catch(error => {
      console.log(error)
    })
  }

  document.title = 'پیام‌ها'

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'messages'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={peykIcon} width={30} alt='resturantIcon' />
              </div>
              <div className='text'>
                پیغام جدید
              </div>
            </div>
          </div>

          <form className='form' onSubmit={handleSubmit(onSubmit)}>
            <div className='title'>
              * تمامی اطلاعات رو پر کنید
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات پیام
              <hr />
            </div>
            <div className='row'>
              <div className='column'>
                <label htmlFor='foodName'>عنوان پیغام * :</label>
                <input id='foodName' {...register("title", { required: true, minLength: 3 })} type='text' placeholder='مثلا سلام' />
                <small id='foodNameAlert'>نام باید وارد شود</small>
              </div>
              <div className='column'>
                <label htmlFor='foodPrice'>پیک * :</label>
                <select id='resturantName' {...register("peyk", { 
                  required: true })}>
                  <option id=''>انتخاب کنید</option>
                  {peyks ? peyks?.map((item, index) => (
                    <option key={index} value={item._id}>{item.name}</option>
                  )) : ''}
                </select>
              </div>
            </div>
            <div className='row'>
              <div className='column textarea'>
                <label htmlFor='foodDetail'>پیغام * :</label>
                <textarea id='foodDetail' rows={5} placeholder='پیغام' {...register("description", { required: true })} />
                <small id='foodDetailAlert'>توضیحات باید وارد شود</small>
              </div>
            </div>
            <button className='createButton' type='submit' style={clickButton ? { backgroundColor: 'gray' } : {}} disabled={clickButton ? true : false}>{clickButton ? 'در حال ارسال ...' : 'ارسال پیغام'}</button>
          </form>
          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
